import * as XLSX from "xlsx";


const ValidateContributionFile = async (file: File): Promise<boolean> => {
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = (event: ProgressEvent<FileReader>) => {
            const result = event.target?.result;

            if (!result) {
                reject(new Error("File read error"));
                return;
            }

            const data = new Uint8Array(result);

            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            let isValid = true;

            for (const row of jsonData) {
                const emp = row["Employee Contribution"];
                const employer = row["Employer Contribution"];

                if (
                    (emp !== undefined && hasMoreThanTwoDecimals(emp)) ||
                    (employer !== undefined && hasMoreThanTwoDecimals(employer))
                ) {
                    isValid = false;
                    break;
                }
            }

            resolve(isValid);
        };

        reader.onerror = () => {
            reject(new Error("File read failed"));
        };
    });
};

const hasMoreThanTwoDecimals = (value: number | string): boolean => {
    const str = value.toString();
    const decimalPart = str.split(".")[1] || "";
    return decimalPart.length > 2;
};

export default ValidateContributionFile;